// extracted by mini-css-extract-plugin
module.exports = {"chartFrame":"TrendingWidget_chartFrame__WQ02K"};